import { render, staticRenderFns } from "./NewspaperDark.vue?vue&type=template&id=3d2b07dc&scoped=true"
var script = {}
import style0 from "./NewspaperDark.vue?vue&type=style&index=0&id=3d2b07dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b07dc",
  null
  
)

export default component.exports